export default __webpack_public_path__ + "static/media/youtube.cf2d8e5f.svg";